
import AddBoxIcon from '@mui/icons-material/AddBox';
import DvrIcon from '@mui/icons-material/Dvr';
import CommuteIcon from '@mui/icons-material/Commute';
import AssessmentIcon from '@mui/icons-material/Assessment';
import AutoGraphIcon from '@mui/icons-material/AutoGraph';
const NavItem=[
    {
    path:"/dashbord",
    name:"Dashbord",
    icon:<AssessmentIcon />
    },
    {
        path:"/Add-Memeber",
        name:"Add Memeber",
        icon:<AddBoxIcon />
        },
        {
            path:"/view-memebership",
            name:" view Memebership",
            icon:<DvrIcon />
            },
            {
                path:"/Payment-reports",
                name:"Payment reports",
                icon:<AutoGraphIcon />
                },
    ];
    export default NavItem;